import facebook from '@/assets/images/social/facebook.png'
import instagram from '@/assets/images/social/instagram.png'
import line from '@/assets/images/social/line.png'
import qr_line from '@/assets/images/social/qr_line.jpg'
import telegram from '@/assets/images/social/telegram.png'
import twitter from '@/assets/images/social/twitter.png'
import youtube from '@/assets/images/social/youtube.png'

export const imgSocialMedia = Object.assign(
  {},
  {
    facebook,
    instagram,
    line,
    qr_line,
    telegram,
    twitter,
    youtube,
  },
)
